module.exports = __webpack_public_path__ + "static/floating-action-button-position-dont-fb23dee70d4d679597d8076196b39e34.png";